function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import Common from "./includes/Common";
import { Descriptions, Alert, Button, Tag, Drawer, Space } from "antd";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { Icon } from "@iconify/react";
import OneFileRecord from "./OneFileRecord";
import { BoxArrowUpRight, Clipboard2PulseFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RecordHistory = function RecordHistory(_ref) {
  var candidate = _ref.candidate;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    archives = _useState4[0],
    setArchives = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    loadError = _useState6[0],
    setLoadError = _useState6[1];
  var ref = useRef();
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedCandidate = _useState8[0],
    setSelectedCandidate = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showInside = _useState0[0],
    setShowInside = _useState0[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getrecordhistory/" + candidate.id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setArchives(response.data.archives);
      } else {
        setLoadError(response.data.message);
      }
    })["catch"](function (error) {
      setLoadError("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsDataLoading(true);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loadError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      message: loadError,
      type: "error"
    }), /*#__PURE__*/_jsxs("div", {
      children: [archives != null && /*#__PURE__*/_jsx(_Fragment, {
        children: archives.length > 0 ? /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(Table, {
            bordered: true,
            responsive: true,
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "Date de visite"
                }), /*#__PURE__*/_jsx("th", {
                  children: "D\xE9cision d'aptitude"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Recommandation"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Status"
                }), /*#__PURE__*/_jsx("th", {})]
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: archives.map(function (c) {
                return /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: c.created_at,
                      format: "DD/MM/YYYY"
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                      children: "A"
                    }) : /*#__PURE__*/_jsx("div", {
                      children: "I"
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.conclusion && c.conclusion.mr_recommandation
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                      style: {
                        width: "6px",
                        borderRadius: "6px",
                        height: "6px",
                        background: "cyan"
                      },
                      color: "cyan",
                      bordered: false
                    }) : /*#__PURE__*/_jsx("div", {
                      style: {
                        width: "6px",
                        borderRadius: "6px",
                        height: "6px",
                        background: "red"
                      },
                      color: "cyan",
                      bordered: false
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsxs(Button, {
                      type: "default",
                      icon: /*#__PURE__*/_jsx(Clipboard2PulseFill, {}),
                      onClick: function onClick() {
                        setSelectedCandidate(c);
                        setShowInside(true);
                      },
                      children: [" ", /*#__PURE__*/_jsx("b", {
                        children: " Recap."
                      })]
                    })
                  })]
                }, c.id);
              })
            })]
          })
        }) : /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(Alert, {
            message: "Aucune visite recente",
            type: "info"
          })
        })
      }), selectedCandidate && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Drawer, {
          open: showInside,
          title: /*#__PURE__*/_jsxs("b", {
            children: ["D\xE9tails dossier ", selectedCandidate.link != null && selectedCandidate.link.length > 4 && /*#__PURE__*/_jsx(Tag, {
              icon: /*#__PURE__*/_jsx(BoxArrowUpRight, {}),
              children: /*#__PURE__*/_jsx("a", {
                href: selectedCandidate.link,
                target: "_blank",
                children: "dossier externe"
              })
            })]
          }),
          width: "90%",
          centered: true,
          onClose: function onClose() {
            setShowInside(false);
          },
          destroyOnClose: true,
          children: /*#__PURE__*/_jsx(OneFileRecord, {
            ref: ref,
            candidat: selectedCandidate
          })
        })
      })]
    })]
  });
};
export default RecordHistory;